export const FETCH_PREVIOUS_UPLOAD_LIST = 'src/Analyst/Cases/Bulk-Cases/action/Fetch_Previous_Upload_List';
export const FETCH_PREVIOUS_UPLOAD_LIST_SUCCESS = 'src/Analyst/Cases/Bulk-Cases/action/Fetch_Previous_Upload_List_Success';
export const FETCH_PREVIOUS_UPLOAD_LIST_FAILURE = 'src/Analyst/Cases/Bulk-Cases/action/Fetch_Previous_Upload_List_Failure'

export const fetchUploadList = (data) => {
    return {
        type: FETCH_PREVIOUS_UPLOAD_LIST,
        data
    }
}
export const fetchUploadListSuccess = (data) => {
    return {
        type: FETCH_PREVIOUS_UPLOAD_LIST_SUCCESS,
        data
    }
}
export const fetchUploadListFailure = (data) => {
    return {
        type: FETCH_PREVIOUS_UPLOAD_LIST_FAILURE,
        data
    }
}

export const DOWNLOAD_BULK_CASE_TEMPLATE = 'src/Analyst/Cases/Bulk-Cases/action/Dowbload_Bulk_Case_Template';
export const DOWNLOAD_BULK_CASE_TEMPLATE_SUCCESS = 'src/Analyst/Cases/Bulk-Cases/action/Dowbload_Bulk_Case_Template_Success';
export const DOWNLOAD_BULK_CASE_TEMPLATE_FAILURE = 'src/Analyst/Cases/Bulk-Cases/action/Dowbload_Bulk_Case_Template_Failure'

export const downloadTemplate = (data) => {
    return {
        type: DOWNLOAD_BULK_CASE_TEMPLATE,
        data
    }
}
export const downloadTemplateSuccess = (data) => {
    return {
        type: DOWNLOAD_BULK_CASE_TEMPLATE_SUCCESS,
        data
    }
}
export const downloadTemplateFailure = (data) => {
    return {
        type: DOWNLOAD_BULK_CASE_TEMPLATE_FAILURE,
        data
    }
}

export const UPLOAD_QUICK_BULK_CASES = 'src/Analyst/Cases/Bulk-Cases/action/Upload_Quick_Bulk_Cases';
export const UPLOAD_QUICK_BULK_CASES_SUCCESS = 'src/Analyst/Cases/Bulk-Cases/action/Upload_Quick_Bulk_Success';
export const UPLOAD_QUICK_BULK_CASES_FAILURE = 'src/Analyst/Cases/Bulk-Cases/action/Upload_Quick_Bulk_Failure';

export const uploadQuickBulkCases = (data) => {
    return {
        type: UPLOAD_QUICK_BULK_CASES,
        data
    }
}
export const uploadQuickBulkCasesSuccess = (data) => {
    return {
        type: UPLOAD_QUICK_BULK_CASES_SUCCESS,
        data
    }
}
export const uploadQuickBulkCasesFailure = (data) => {
    return {
        type: UPLOAD_QUICK_BULK_CASES_FAILURE,
        data
    }
}

export const UPLOAD_BULK_CASES = 'src/Analyst/Cases/Bulk-Cases/action/Upload_Bulk_Cases';
export const UPLOAD_BULK_CASES_SUCCESS = 'src/Analyst/Cases/Bulk-Cases/action/Upload_Bulk_Cases_Success';
export const UPLOAD_BULK_CASES_FAILURE = 'src/Analyst/Cases/Bulk-Cases/action/Upload_Bulk_Cases_Failure';

export const uploadBulkCases = (data) => {
    return {
        type: UPLOAD_BULK_CASES,
        data
    }
}
export const uploadBulkCasesSuccess = (data) => {
    return {
        type: UPLOAD_BULK_CASES_SUCCESS,
        data
    }
}
export const uploadBulkCasesFailure = (data) => {
    return {
        type: UPLOAD_BULK_CASES_FAILURE,
        data
    }
}

export const DOWNLOAD_BULK_CASES_FILE = 'src/Analyst/Cases/Bulk-Cases/action/Download_Bulk_Cases_File';
export const DOWNLOAD_BULK_CASES_FILE_SUCCESS = 'src/Analyst/Cases/Bulk-Cases/action/Download_Bulk_Cases_File_Success';
export const DOWNLOAD_BULK_CASES_FILE_FAILURE = 'src/Analyst/Cases/Bulk-Cases/action/Download_Bulk_Cases_File_Failure';

export const downloadBulkCasesFile = (data) => {
    return {
        type: DOWNLOAD_BULK_CASES_FILE,
        data
    }
}
export const downloadBulkCasesFileSuccess = (data) => {
    return {
        type: DOWNLOAD_BULK_CASES_FILE_SUCCESS,
        data
    }
}
export const downloadBulkCasesFileFailure = (data) => {
    return {
        type: DOWNLOAD_BULK_CASES_FILE_FAILURE,
        data
    }
}